import React from 'react';
import { useDispatch } from 'react-redux';
import ConfirmationModalNew from './ConfirmationModalNew';
import Button from './Button';

/**
 * Reusable modal component for displaying password history error
 * Shows when user tries to use a previously used password
 * 
 * @param {boolean} open - Controls modal visibility
 * @param {function} onClose - Callback when modal is closed
 * @param {string} clearErrorActionType - Redux action type to clear the error (e.g., "CLEAR_CHANGE_PASSWORD_ERROR" or "CLEAR_CHANGE_MYPROFILE_PASSWORD_ERROR")
 */
const PasswordHistoryErrorModal = ({ open, onClose, clearErrorActionType }) => {
  const dispatch = useDispatch();

  const handleClose = () => {
    if (clearErrorActionType) {
      dispatch({ type: clearErrorActionType });
    }
    if (onClose) {
      onClose();
    }
  };

  return (
    <ConfirmationModalNew
      open={open}
      title="Password Security Reminder"
      confirmText="Okay"
      className='!p-0 !w-[90%] !max-w-[90%] md:!w-[630px] md:!min-w-[630px] md:!max-w-[630px]'
      type="primary"
      content={() => (
        <div className="text-left px-4 md:px-0">
          <p className="text-md text-gray-800 mb-6 md:mb-8">
            For your security and to protect sensitive clinical data, passwords must be unique to each system and must not be reused.
          </p>

          <p className="text-sm text-gray-800">
            Reusing passwords increases the risk of unauthorized access and data breaches.
          </p>
        </div>
      )}
      onCross={handleClose}
      hideActions={false}
      hideCloseIcon={false}
      confirmAction={handleClose}
      cancelAction={handleClose}
    />
  );
};

export default PasswordHistoryErrorModal;

